import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BoatSailorService {

constructor(private http: HttpClient) { }

getListBoatSailorByUserId(id: number): Observable<any[]> {
  return this.http.get(
      environment.apiHost + '/secure/sailor/boatsailorbyid/' + id
  ).pipe(map((response: any) => response.data.boatsailors as any[]));
}

}
